import { render, staticRenderFns } from "./NewTaskFlow.vue?vue&type=template&id=1a64daf7&scoped=true"
import script from "./NewTaskFlow.vue?vue&type=script&lang=js"
export * from "./NewTaskFlow.vue?vue&type=script&lang=js"
import style0 from "./NewTaskFlow.vue?vue&type=style&index=0&id=1a64daf7&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a64daf7",
  null
  
)

export default component.exports